import React from 'react';
import { useState, useEffect } from 'react'

import { Link } from 'react-router-dom';
import { db, user } from '../../../../firebase';
import { doc, getDocs, collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';


import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import PortfolioHeader from '../Header';

const Home = () => {

    const [tasks, setTasks] = useState([])


    useEffect(() => {
        /* signInWithEmailAndPassword(auth, 'eastrosesun@mitr.com', 'welcome')
        .then((userCredential) => { 
            console.log('auth completed');
            fetchData(); 
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
        }); */
        if (user) {
            fetchData();
        }
        document.body.classList.add('portfolio');
    }, [])

    const fetchData = async() => {
        const querySnapshot = await getDocs(collection(db, "portfolio"));
        setTasks(querySnapshot.docs.map(doc => ({
            id: doc.id,
            data: doc.data()
        })))

        // console.log(tasks[0].data.project_title);
        /* const response = db.collection('documents');
        const data=await response.get();
        console.log(data); */
        /* const docRef = doc(db, "documents", "SF");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
        } */
        /*  const citiesRef = db.collection('documents');
         const snapshot = await citiesRef.get();
         snapshot.forEach(doc => {
         console.log(doc.id, '=>', doc.data());
         }); */
    }
    return ( <>
        <PortfolioHeader / >
        <div className = "mainContainer" >
        <div className = "landingImage" >
        <div className = "skin1links" >
        <Link to = "/frontend"
        style = {
            { top: '30px', display: 'block', position: 'absolute', left: '10px', width: '165px', height: '90px' }
        }
        title = "Frontend" > &nbsp; </Link> <
        Link to = "portfoliosubcategory.php?portfolio_id=2&proj_type_id=null&project_type=null"
        style = {
            { left: '255px', top: '25px', width: '190px', height: '95px', display: 'block', position: 'absolute' }
        }
        title = "newsletter design" > &nbsp; </Link> 
        <Link to = "portfoliosubcategory.php?portfolio_id=3&proj_type_id=null&project_type=null"
        style = {
            { left: '715px', top: '30px', width: '200px', height: '95px', display: 'block', position: 'absolute' }
        }
        title = "sharepoint design" > &nbsp; </Link> 
        <Link to = "testimonials.php?portfolio_id=4"
        style = {
            { left: '1005px', top: '5px', width: '200px', height: '95px', display: 'block', position: 'absolute' }
        }
        title = "testimonials" > &nbsp; </Link> 
        </div > 
        </div> 
        <div className = "cloud1" > <Link to = "/portfolio/frontend"
        style = {
            { display: 'block' }
        } > &nbsp; </Link></div>
        <div className = "cloud2" > <Link to = "/portfolio/uiux"
        style = {
            { display: 'block' }
        } > &nbsp; </Link></div >
        <
        div className = "cloud3" > <Link to = "/portfolio/middleware"
        style = {
            { display: 'block' }
        } > &nbsp; </Link></div >
        <div className = "cloud4" > <Link to = "/portfolio/digitalmarketing"
        style = {
            { display: 'block' }
        } > &nbsp; </Link></div>
        <div className = "wheel0" > </div> 
        <div className = "wheel1" > </div> 
        <div className = "wheel2" > </div> 
        <div className = "wheel3" > </div>
        <p className = "title1" > i create experiences that <span> matter </span></p >
        <p className = "subtitle1" > i am a web designer / developer who is passionate about designing / developing user interfaces
        for the web, mobile & print. <br /> </p> 
        <hr / >
        </div> 
        </>
    )
}

export default Home;